import {SEASON} from "../../components/constants.js";
import { memo } from 'react';
import { useTranslation } from "react-i18next";
import {useSharedLang} from '../../hooks/useSharedLang.js'

const MapControlFlower = memo((props) => {
  const {selectedSeasonList,toggleSeason} = props;
  const { sharedLang } = useSharedLang();
  const { t } = useTranslation();

  // 現在の季節の設定
  const getSeasonList = () => {
    let dateNow = new Date();
    let dateMonth = dateNow.getMonth() + 1; //0スタートのため1を足す

    //--- 春から固定に ---
    // if (dateMonth >= 3 && dateMonth <= 5) {
    //   return [SEASON.SPRING,SEASON.SUMMER,SEASON.AUTUMN,SEASON.WINTER];
    // } else if (dateMonth >= 6 && dateMonth <= 8) {
    //   return [SEASON.SUMMER,SEASON.AUTUMN,SEASON.WINTER,SEASON.SPRING];
    // } else if (dateMonth >= 9 && dateMonth <= 11) {
    //   return [SEASON.AUTUMN,SEASON.WINTER,SEASON.SPRING,SEASON.SUMMER];
    // } else {
    //   return [SEASON.WINTER,SEASON.SPRING,SEASON.SUMMER,SEASON.AUTUMN];
    // }  
    return [SEASON.SPRING,SEASON.SUMMER,SEASON.AUTUMN,SEASON.WINTER];
  }
  const getSeasonName = (code) => {
    switch(code){
      case 'spring':
        return t("nature.season_spring");
      case 'summer':
        return t("nature.season_summer");
      case 'autumn':
        return t("nature.season_autumn");
      case 'winter':
        return t("nature.season_winter");
      default:
        return t("nature.season_all");
    }
  }

  const onClick = (season) => {
    let code = season.code;
    let newSeasonList = [...selectedSeasonList];

    if(isActive(code)){
      newSeasonList = selectedSeasonList.filter((val) => val !== code);
    }else{
      newSeasonList.push(code);
    }
    toggleSeason(newSeasonList);
  }

  const isActive = (code) => {
    return selectedSeasonList.includes(code);
  }

  return (
    <div className="flower-control leaflet-bottom leaflet-right">
    {
      getSeasonList().slice().reverse().map((season, index) => {
        var className = "leaflet-control leaflet-bar " + season.code + " " + sharedLang;
        
        if(isActive(season.code)){
          className += " active";
        }

        return <div className={className} key={season.code}>
          <button onClick={() => onClick(season)}>{getSeasonName(season.code)}</button>
        </div>
      })
    }
    </div>
  )
});
  
export default MapControlFlower